import { IS_HIDDEN, IS_ACTIVE } from '/source/js/base/baseClasses';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { validation } from '/source/_patterns/01-components/form/form';

function forgotData(e) {
    e.preventDefault();
    let $this = $(this);
    let $authState = $('.auth__state');
    loadSpinner();

    setTimeout(function() {
        stopSpinner();
        $authState.addClass(IS_HIDDEN);
        $this.parents($authState).next().removeClass(IS_HIDDEN);
        let $stateToggle = $('.auth-state__toggle');
        let $stateSuccessToggle = $('.auth-state__toggle--success');
        $stateToggle.removeClass(IS_ACTIVE);
        $stateSuccessToggle.addClass(IS_ACTIVE);
    }, 1000);
}

function validateNewPassword() {
    let $cvvReview = $('#newPassword');
    $cvvReview.validate(validation);
}

function initEventHandlers() {
    let $authSubmit = $('.auth__submit');
    $authSubmit.on('click', forgotData);
    validateNewPassword();
}

$(function () {
    initEventHandlers();
});
